import React from 'react';
import sIcon1 from '../../images/icon/ab-page-icon01.svg'
import sIcon2 from '../../images/icon/ab-page-icon02.svg'
import sIcon3 from '../../images/icon/ab-page-icon03.svg'
import sIcon4 from '../../images/icon/ab-page-icon04.svg'


const FeaturesSection = (props) => {

    return (
        <section className="fanfact pt-125 pb-125">
            <div className="container">
                <div className="ap-feature_wrap">
                    <div className="row mt-none-30">
                        <div className="col-lg-3 col-md-6 mt-30">
                            <div className="ap-feature-item wow fadeInUp" data-wow-delay="0ms" data-wow-duration="600ms">
                                <div className="xb-item--icon"><img src={sIcon1} alt="Outcome-driven delivery"/></div>
                                <h4 className="xb-item--title">Outcome-Driven</h4>
                                <p className="xb-item--content">We measure success by the business results our software delivers, not features shipped.</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 mt-30">
                            <div className="ap-feature-item wow fadeInUp" data-wow-delay="100ms" data-wow-duration="600ms">
                                <div className="xb-item--icon"><img src={sIcon2} alt="Proactive engineering"/></div>
                                <h4 className="xb-item--title">Proactive Engineering</h4>
                                <p className="xb-item--content">We anticipate risks early, automate the busywork, and keep your roadmap moving.</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 mt-30">
                            <div className="ap-feature-item wow fadeInUp" data-wow-delay="200ms" data-wow-duration="600ms">
                                <div className="xb-item--icon"><img src={sIcon3} alt="Scalable by design"/></div>
                                <h4 className="xb-item--title">Scalable by Design</h4>
                                <p className="xb-item--content">Cloud-native systems engineered to grow with your users, traffic, and ambitions.</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 mt-30">
                            <div className="ap-feature-item wow fadeInUp" data-wow-delay="300ms" data-wow-duration="600ms">
                                <div className="xb-item--icon"><img src={sIcon4} alt="Fast secure delivery"/></div>
                                <h4 className="xb-item--title">Velocity, Secured</h4>
                                <p className="xb-item--content">Rapid delivery with security and quality built into every sprint and release.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default FeaturesSection;